import { Box, Menu, MenuProps } from '@mui/material';
import React from 'react';

import { NotificationList } from './NotificationList';

type NotificationModalProps = Omit<MenuProps, 'children'>;

export const NotificationModal: React.FC<NotificationModalProps> = (props) => {
  return (
    <Menu
      {...props}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      PaperProps={{
        sx: {
          width: 400,
          maxHeight: 600,
          overflow: 'hidden',
          mt: 1.5,
        },
      }}
    >
      <Box>
        <NotificationList />
      </Box>
    </Menu>
  );
};
